import { Component, OnInit } from '@angular/core';
import {Router, Params, ActivatedRoute} from '@angular/router';
import { ForumService } from '../forum.service';
import { Topic } from '../topic';
import { ForumMessage } from '../forummessage';

@Component({
    selector: 'topicDetail',
    template: require('./topic-detail.component.html'),    
    providers: [ForumService]
})

export class ForumTopicDetailComponent implements OnInit {        

    router: Router;
    userStatus: string;
    topic: Topic;
    messagesForum: ForumMessage[];    
    messageModal: any;
    messageContent: string;
    messageError: boolean;
    messageToAnswer: ForumMessage;
    classLoginModal: any;
    loginCode: number;
    loginEmail: string;
    loginPassword: string;
    classForgetPasswordModal: any;
    forgetPasswordEmail: string;   
    forgetPasswordEmailEmpty: boolean;
    forgetPasswordEmailIncorrect: boolean; 
    classEmailSendedModal: any;
    emailSended: boolean;   

    constructor(private _forumService: ForumService, private _parentRouter: Router, private route: ActivatedRoute) {
        this.router = _parentRouter;
        this.userStatus = "";
        this.topic = {id: 0, name: "", forum_id: 0, user_id: 0, user_name: "", creation_date: new Date()};
        this.messagesForum = [];        
        this.messageModal = { 'model': true, 'show': false, 'hide': true };
        this.messageContent = "";
        this.messageError = false;
        this.messageToAnswer = null;
        this.classLoginModal = { 'model': true, 'show': false, 'hide': true };
        this.classForgetPasswordModal = { 'model': true, 'show': false, 'hide': true };
        this.loginCode = 0;
        this.loginEmail = "";
        this.loginPassword = "";    
        this.forgetPasswordEmail = "";
        this.forgetPasswordEmailEmpty = false;
        this.forgetPasswordEmailIncorrect = false;  
        this.classEmailSendedModal = { 'model': true, 'show': false, 'hide': true };
        this.emailSended = false;
    }

    ngOnInit() {
        this._forumService.getUserStatus().then(status => {
            this.userStatus = status.role;
        });

        this._forumService.getTopicById(parseInt(this.route.snapshot.params['topic_id'])).then(res => {
            if(res != null) {
                this.topic = res;
                this._forumService.getForumMessagesByTopicId(this.topic.id).then(res2 => {
                    if(res2 != null) {
                        this.messagesForum = res2;                                                   
                    }
                });
            }
        });
    }

    messageClicked(message: ForumMessage, event: any) {                
        
        if(message.selected) {
            this.collapseMessage(message);            
        } else {
            if(message.childs.length > 0) {
                message.selected = true;
            }            
        }
            
    }

    collapseMessage(message: ForumMessage) {
        message.selected = false;

        if(message.childs.length > 0) {
            for(var i = 0; i < message.childs.length; i++) {
                this.collapseMessage(message.childs[i]);
            }
        }
    }

    answerClicked(message: ForumMessage) {        
        this.messageToAnswer = message;
        this.messageModal.show = true;
        this.messageModal.hide = false;
    }

    addNewMessage() {
        if(this.userStatus != "guest") {
            this.messageToAnswer = null;
            this.messageModal.show = true;
            this.messageModal.hide = false;
        } else {
            this.classLoginModal.show = true;
            this.classLoginModal.hide = false;
        }
    }

    messageReceived(event: any) {                
        this.answerClicked(event.value);
    }    

    closeMessageModal() {
        this.messageContent = "";
        this.messageError = false;
        this.messageToAnswer = null;
        this.messageModal.show = false;
        this.messageModal.hide = true;
    }

    saveMessageModal() {
        if(this.messageContent != null && this.messageContent != undefined && this.messageContent.length > 0) {
            this.messageError = false;
            var messageToAnswerId = -1;
            if(this.messageToAnswer != null) {                
                messageToAnswerId = this.messageToAnswer.id;
            }            
            this._forumService.postMessage(this.messageContent, this.topic.id, messageToAnswerId).then(res => {                           
                if(res.code == 1) {                
                    if(messageToAnswerId == -1) {             
                        var message: ForumMessage = {
                            "id": res.message_id, 
                            "content": this.messageContent, 
                            "topic_id": this.topic.id, 
                            "user_id": Number(localStorage.getItem("idUser")), 
                            "user_name": localStorage.getItem("userName"), 
                            "forum_message_id": null, 
                            "creation_date": new Date(), 
                            "childs": [], 
                            "selected": false,
                            "messages": 0
                        };                        
                        this.messagesForum.push(message);                    
                    } else {
                        var message: ForumMessage = {
                            "id": res.message_id, 
                            "content": this.messageContent, 
                            "topic_id": this.topic.id, 
                            "user_id": Number(localStorage.getItem("idUser")), 
                            "user_name": localStorage.getItem("userName"), 
                            "forum_message_id": this.messageToAnswer.id, 
                            "creation_date": new Date(), 
                            "childs": [], 
                            "selected": false,
                            "messages": 0
                        };                        
                        this.messageToAnswer.messages++;
                        this.messageToAnswer.childs.push(message);
                        this.messageToAnswer.selected = true;                    
                    }
                    this.closeMessageModal();
                }
            });
        } else {
            this.messageError = true;
        }        
    }
    
    getDaysComments(date: any) {
        var dateNow = new Date();
        var dateComment = new Date(date);
        var difference = dateNow.getTime()/1000 - dateComment.getTime()/1000;
        return Math.floor(difference/60/60/24);
    }

    getHoursComments(date: any) {
        var dateNow = new Date();
        var dateComment = new Date(date);
        var difference = dateNow.getTime()/1000 - dateComment.getTime()/1000;
        return Math.floor(difference/60/60);

    }

    closeLoginModal() {
        this.loginCode = 0;
        this.classLoginModal.show = false;
        this.classLoginModal.hide = true;
    }

    loginClicked() {

        this._forumService.login(this.loginEmail, this.loginPassword).subscribe(result => {
            this.loginCode = result.code;
            if (result !== null && result.token !== undefined) {                
                localStorage.setItem('userName', result.user.name);                
                localStorage.setItem('idUser', result.user.id.toString());
                location.reload();
                //this.router.navigate(['/main', 'dashboard']);
            }
        });

    }

    registerClicked() {
        this.router.navigate(['/register']);
    } 

    forgetPassword() {
        this.classLoginModal.show = false;
        this.classLoginModal.hide = true;
        this.classForgetPasswordModal.show = true;
        this.classForgetPasswordModal.hide = false;
    }

    closeForgetPasswordModal() {
        this.classForgetPasswordModal.show = false;
        this.classForgetPasswordModal.hide = true;
        this.forgetPasswordEmail = "";
        this.forgetPasswordEmailEmpty = false;
        this.forgetPasswordEmailIncorrect = false;
    }

    getPasswordByEmail() {
        if(this.forgetPasswordEmail != undefined && this.forgetPasswordEmail != null && this.forgetPasswordEmail != "") {
            this.forgetPasswordEmailEmpty = false;
            this._forumService.verifyEmail(this.forgetPasswordEmail).then(res => {
                if(res) {                    
                    this.forgetPasswordEmailIncorrect = false;
                    this._forumService.sendEmailRecoverPassword(this.forgetPasswordEmail).then(res => {
                        if(res == 1) {
                            this.classForgetPasswordModal.show = false;
                            this.classForgetPasswordModal.hide = true;
                            this.forgetPasswordEmailEmpty = false;
                            this.forgetPasswordEmailIncorrect = false;

                            this.classEmailSendedModal.show = true;
                            this.classEmailSendedModal.hide = false;
                        }
                    })
                } else {
                    this.forgetPasswordEmailIncorrect = true;
                }
            });
        } else {
            this.forgetPasswordEmailEmpty = true;
        }
    }

    resendEmailRecoverPassword() {
        this._forumService.sendEmailRecoverPassword(this.forgetPasswordEmail).then(res => {            
            if (res == 1) {                
                this.emailSended = true;
            }
        });
    }

    closeEmailSendedModal() {
        this.classEmailSendedModal.show = false;
        this.classEmailSendedModal.hide = true;
        this.forgetPasswordEmail = "";
        this.emailSended = false;
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/forum/topic_detail/topic-detail.component.ts
 **/